import React, { createContext, useContext } from 'react';

/** Default: editable (legacy pages without a provider stay unchanged). */
const ScopeThreeFormEditContext = createContext<{ isEditView: boolean }>({
  isEditView: true,
});

export const ScopeThreeFormEditProvider: React.FC<{
  isEditView: boolean;
  children: React.ReactNode;
}> = ({ isEditView, children }) => (
  <ScopeThreeFormEditContext.Provider value={{ isEditView }}>
    {children}
  </ScopeThreeFormEditContext.Provider>
);

export const useScopeThreeFormEdit = (): { isEditView: boolean } =>
  useContext(ScopeThreeFormEditContext);
